import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileCTA from "@/components/common/MobileCTA";
import CustomCursor from "@/components/common/CustomCursor";
import CookieBanner from "@/components/common/CookieBanner";
import BackToTop from "@/components/common/BackToTop";
import WhatsAppButton from "@/components/common/WhatsAppButton";
import LogoIntro from "@/components/common/LogoIntro";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import LeistungDetail from "@/pages/LeistungDetail";
import Projekte from "@/pages/Projekte";
import ProjektDetail from "@/pages/ProjektDetail";
import UeberUns from "@/pages/UeberUns";
import Nachhaltigkeit from "@/pages/Nachhaltigkeit";
import Magazin from "@/pages/Magazin";
import ArtikelDetail from "@/pages/ArtikelDetail";
import Karriere from "@/pages/Karriere";
import Kontakt from "@/pages/Kontakt";
import Anfrage from "@/pages/Anfrage";
import Admin from "@/pages/Admin";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import HolzSpiel from "@/pages/HolzSpiel";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-white font-inter">
      <CustomCursor />
      <Header />
      <main>{children}</main>
      <Footer />
      <MobileCTA />
      <CookieBanner />
      <BackToTop />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <LogoIntro />
        <ScrollToTop />
        <AppLayout>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/leistungen/:slug" element={<LeistungDetail />} />
          <Route path="/projekte" element={<Projekte />} />
          <Route path="/projekte/:id" element={<ProjektDetail />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/nachhaltigkeit" element={<Nachhaltigkeit />} />
          <Route path="/magazin" element={<Magazin />} />
          <Route path="/magazin/:slug" element={<ArtikelDetail />} />
          <Route path="/karriere" element={<Karriere />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/anfrage" element={<Anfrage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/spiel" element={<HolzSpiel />} />
        </Routes>
        </AppLayout>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
